import './App.css';
import Navbars from './components/Navbars';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React from 'react';
import Movies from './components/Movies';
import Favourites from './components/Favourites';
//https:react-bootcamp-movieapp.netlify.app/
function App() {
  return (
    <>
    <Router>
    <Navbars/>
    <Routes>
    <Route exact path="/" element={<Movies/>}/>
    <Route exact path="/Favourites" element={<Favourites/>}/>
    </Routes>
    </Router>

    </>
   
  );
}
export default App;